<template>
  <v-container class="vpd-privacy-policy" fluid>
    <vpd-md-viewer
      :source="source"
      title="Általános szerződési feltételek"
    />
  </v-container>
</template>

<script>
import VpdMdViewer from "../components/vpd-md-viewer/vpd-md-viewer";
import Doc from "../assets/services-terms-and-conditions.md";

export default {
  name: "services-terms-and-conditions-policy",
  components: {
    VpdMdViewer,
  },
  data() {
    return {
      source: Doc,
    };
  },
  methods: {},
};
</script>
